import gql from 'graphql-tag';

import userFragment from './user-fragment';

export default gql`
  mutation updateByIdUserMutation(
    $_id: MongoID!
    $record: UpdateByIdUserInput!
  ) {
    updateByIdUserMutation(_id: $_id, record: $record) {
      title
      message
      record {
        ...UserFragment
      }
    }
  }
  ${userFragment}
`;
